import { useMemo } from "react";
import type { CityHallStateResponse } from "../../client";
import type { UserData } from "../../models/user";

export interface UseCityHallSelectionParams {
  registerSuccessCandidateId: number | null;
  state: CityHallStateResponse | undefined;
  userData: UserData | undefined;
}

export interface UseCityHallSelectionResult {
  currentUserCandidateId: number | null;
  registerSuccessDisplayCandidateId: number | null;
}

/** Which candidate is "in play": the viewer's own (for register-success display). */
export function useCityHallSelection({
  registerSuccessCandidateId,
  state,
  userData,
}: UseCityHallSelectionParams): UseCityHallSelectionResult {
  // Отримуємо ID кандидата поточного користувача для екрану успішної реєстрації
  // Dep on `state` (not state?.candidates): React Compiler needs a stable base path.
  const currentUserCandidateId = useMemo(() => {
    if (!state?.candidates || !userData) return null;
    const userId = parseInt(userData.user_id, 10);
    const candidate = state.candidates.find((c) => c.user_id === userId);
    return candidate?.id || null;
  }, [state, userData]);

  const registerSuccessDisplayCandidateId =
    registerSuccessCandidateId ?? currentUserCandidateId;

  return {
    currentUserCandidateId,
    registerSuccessDisplayCandidateId,
  };
}
